import StudyCenterNav from './src/main';

/* istanbul ignore next */
StudyCenterNav.install = function(Vue) {
  Vue.component(StudyCenterNav.name, StudyCenterNav);
};

export default StudyCenterNav;
